import Memento from "./memento-mori";
import Inferno from "./inferno"

export default {
    memento: Memento,
    inferno: Inferno
}